<template>
  <ProductPageLayout
    name="Everyfile"
    :logo="logo"
    :hero-image="heroImage"
    lead="更快、更准、更轻量的 Windows 文件搜索工具，毫秒级定位目标文件与系统关键项。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/Everyfile/EveryfileSetup.exe"
    download-file-name="EveryfileSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="毫秒级索引检索，多视图浏览与智能过滤，让文件管理更高效。"
    other-desc="针对文件检索、结构整理与常用入口场景，提供一体化效率能力。"
    reviews-desc="真实反馈持续驱动 Everyfile 的搜索体验优化与效率升级。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'Everyfile',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/Everyfile/everyfile_48x48.png'),
      heroImage: require('@/assets/Everyfile/详细视图.png'),
      featureLines: [
        '全盘搜索 / 路径过滤 / 关键字匹配 / 快速定位',
        '列表模式 / 图标模式 / 收藏夹 / 右键快捷操作'
      ],
      metaItems: [
        { icon: 'fast', label: '毫秒响应' },
        { icon: 'search', label: '精准定位' },
        { icon: 'image', label: '多视图管理' }
      ],
      detailedFeatures: [
        {
          title: '极速索引引擎',
          brief: '文件再多也能快速出结果，搜索响应接近实时。',
          detail: '依托高效索引机制，面对大量文档、媒体和项目目录时，依旧能保持毫秒级检索体验。',
          image: require('@/assets/Everyfile/列表模式.png')
        },
        {
          title: '智能过滤系统',
          brief: '组合过滤条件，定位目标文件更精准。',
          detail: '支持按文件类型、路径关键字和时间区间筛选，在复杂目录结构中快速收敛结果范围。',
          image: require('@/assets/Everyfile/详细视图.png')
        },
        {
          title: '多视图浏览',
          brief: '列表与图标模式自由切换，兼顾效率和直观性。',
          detail: '在文本信息密集与缩略图预览场景之间快速切换，满足文档管理和素材检视两类需求。',
          image: require('@/assets/Everyfile/中图标.png')
        },
        {
          title: '收藏夹管理',
          brief: '常用路径统一归档，一键直达高频目录。',
          detail: '可将常用文件夹、项目路径或工具入口加入收藏，减少重复跳转，提高日常处理效率。',
          image: require('@/assets/Everyfile/收藏夹.png')
        }
      ],
      otherFeatures: [
        { title: '右键快捷菜单', description: '从文件管理器快速触发搜索与定位。', icon: 'mouse' },
        { title: '超大图标预览', description: '图片和视频素材浏览更直观。', icon: 'image' },
        { title: '路径记忆', description: '保留最近访问路径，持续搜索更顺手。', icon: 'pin' },
        { title: '关键文件高亮', description: '重点结果优先展示，减少重复筛选。', icon: 'sparkle' }
      ],
      reviews: [
        { name: '郭工程师', comment: '日志和配置文件查找效率提升很大，定位问题非常快。', avatar: require('@/assets/Everyfile/avatar1.jpg') },
        { name: '郑老师', comment: '教学资料太多时，关键词搜索能马上找到对应课件。', avatar: require('@/assets/Everyfile/avatar2.jpg') },
        { name: '潘同学', comment: '写论文时找素材方便很多，不用在目录里来回翻。', avatar: require('@/assets/Everyfile/avatar3.jpg') },
        { name: '戴运营', comment: '活动素材管理更清晰，图标模式预览很实用。', avatar: require('@/assets/Everyfile/avatar4.jpg') },
        { name: '程产品', comment: '搜索速度稳定，收藏夹让常用目录管理轻松了不少。', avatar: require('@/assets/Everyfile/avatar5.jpg') },
        { name: '方设计', comment: '图片素材查找很顺畅，交付过程节省很多时间。', avatar: require('@/assets/Everyfile/avatar6.jpg') }
      ]
    }
  }
}
</script>
